import {Partner} from "./partner.model";
import {VetClinic, VetDoctor} from "./vet-clinic.model";
import {User} from "./user.model";
import {PartnerProduct} from "./partner-product.model";

/**
 * Model reprezentujący zrealizowane zamówienie (Transakcję) w sklepie Partnera.
 * Zapisuje, kto kupił, co kupił, od jakiego partnera i przez jaką klinikę/lekarza.
 */
export class PartnerShopOrder {

  /** Globalnie unikalny identyfikator zamówienia. */
  public uuid: string;

  /** Data i czas złożenia zamówienia. */
  public created: Date;

  /** Data realizacji. Wypełniane po zmianie statusu przez partnera. */
  public executionDate: Date;

  public partnerUUID: string;
  public partner: Partner;

  /** ID Klienta Biznesowego, w ramach którego dokonano zakupu. */
  public vClientId: number;

  /** ID konkretnego gabinetu. */
  public vetcodeId: number;
  public vetClinic: VetClinic;

  /** Całkowita wartość zamówienia brutto (do zapłaty). */
  public grossOrderValue: number;

  public pragmaticBoxCode: string;

  /** Lekarz powiązany z zamówieniem. */
  public vetDoctor: VetDoctor;
  public vetDoctorUUID: string;

  /** Identyfikator rekomendacji produktu.
   */
  public productRecommendationUUID: string;


  /** Zserializowany koszyk zakupowy (Snapshot) w momencie płatności. */
  public cartJson: string;
  public user: User;
  public userUUID: string;

  /** Lista żądanych produktów. */
  public partnerProductsRequestList: PartnerProduct[];

  /** Ostateczna lista produktów wchodzących w skład zamówienia. */
  public partnerProductsList: PartnerProduct[];

  /** Flaga usunięcia. */
  public deleted: Date;
}


/**
 * Uproszczony model produktu, dedykowany konkretnej integracji z VetExpert.
 */
export class VetExpertProduct {

  /** Wewnętrzny identyfikator produktu. */
  public id: number;

  /** Adres URL do zdjęcia produktu. */
  public pictureUrl: string;

  /** Nazwa produktu. */
  public name: string;

  /** Opis działania/składu. */
  public description: string;

  /** Cena regularna. */
  public price: number;

  /** Cena po zniżce. */
  public discountPrice: number;

  /** Flaga określająca, czy produkt jest w tym momencie możliwy do kupienia. */
  public isAvailable: boolean;

  /** Liczba sztuk (Ilość).
   */
  public count: number;
}
